<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';

	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-50', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper
	{title}
	viewBox="0 0 36 18"
	width="36"
	height="18"
	{...rest}
	class={twMerge('h-[36px] w-[18px]', rest.class)}
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M0 17.9993H6.00032V0H0V17.9993Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M12.0009 18H24.0016V12.0002H12.0009V18Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M11.9997 6.00044H24.0003V0.000658796H11.9997V6.00044Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M29.9997 17.9995H36V0.000163868H29.9997V17.9995Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
